import { render, staticRenderFns } from "./StockValueTableWidget.vue?vue&type=template&id=1959d9d0&"
import script from "./StockValueTableWidget.vue?vue&type=script&lang=js&"
export * from "./StockValueTableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QTd})
